(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1bunk-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const AUTOPLAY_INTERVAL = 4500; // ms — matches generator (4.5s)
  const TRANSITION_MS = 900;      // must match CSS transition duration

  function initHero(section) {
    const slides   = Array.from(section.querySelectorAll('[data-slide]'));
    const dots     = Array.from(section.querySelectorAll('[data-dot]'));
    const pauseBtn = section.querySelector('[data-pause-btn]');
    const win      = section.querySelector('[data-slideshow]');

    if (!slides.length) return;

    let current   = 0;
    let timer     = null;
    let paused    = false;
    let isTransit = false; // guard rapid taps

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ── core: go to slide N ────────────────────────────────────
    function goTo(n, fromAuto) {
      if (isTransit && !fromAuto) return;
      if (n === current) return;

      isTransit = true;

      slides[current].classList.remove('is-on');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('is-on');
        dots[current].setAttribute('aria-selected', 'false');
      }

      current = (n + slides.length) % slides.length;

      slides[current].classList.add('is-on');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('is-on');
        dots[current].setAttribute('aria-selected', 'true');
      }

      setTimeout(function () { isTransit = false; }, prefersReduced ? 0 : TRANSITION_MS);
    }

    // ── autoplay ───────────────────────────────────────────────
    function start() {
      if (prefersReduced || slides.length < 2) return;
      stop();
      timer = setInterval(function () {
        goTo(current + 1, true);
      }, AUTOPLAY_INTERVAL);
    }
    function stop() {
      clearInterval(timer);
      timer = null;
    }

    // ── pause toggle ───────────────────────────────────────────
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        if (paused) { stop(); } else { start(); }
      });
    }

    // ── dot nav ────────────────────────────────────────────────
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var n = parseInt(dot.getAttribute('data-dot'), 10);
        goTo(n, false);
        if (!paused) { start(); } // reset interval on manual nav
      });
      dot.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { goTo(current - 1, false); start(); }
        if (e.key === 'ArrowRight') { goTo(current + 1, false); start(); }
      });
    });

    // ── swipe / touch ─────────────────────────────────────────
    if (win) {
      var xStart = null;
      win.addEventListener('touchstart', function (e) {
        xStart = e.touches[0].clientX;
      }, { passive: true });
      win.addEventListener('touchend', function (e) {
        if (xStart === null) return;
        var dx = e.changedTouches[0].clientX - xStart;
        if (Math.abs(dx) > 40) {
          goTo(dx < 0 ? current + 1 : current - 1, false);
          if (!paused) start();
        }
        xStart = null;
      }, { passive: true });
    }

    // ── keyboard on win ───────────────────────────────────────
    if (win) {
      win.setAttribute('tabindex', '0');
      win.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { goTo(current - 1, false); if (!paused) start(); }
        if (e.key === 'ArrowRight') { goTo(current + 1, false); if (!paused) start(); }
        if (e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          pauseBtn && pauseBtn.click();
        }
      });
    }

    // ── pause on hover (desktop) ──────────────────────────────
    if (win) {
      win.addEventListener('mouseenter', stop);
      win.addEventListener('mouseleave', function () { if (!paused) start(); });
    }

    // ── init ──────────────────────────────────────────────────
    start();
  }

  // ── boot (section may render in Theme Editor via "on:section:load") ──
  function boot() {
    document.querySelectorAll('.bunk-hero').forEach(initHero);
  }
  document.addEventListener('DOMContentLoaded', boot);

  // Shopify Theme Editor live-reload
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.bunk-hero');
    if (s) initHero(s);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    // timers auto-collected when section is removed from DOM
  });

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2bunk-story"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function initStory(section){
    var beats = section.querySelectorAll('[data-bs-beat]');
    if(!beats.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce){ beats.forEach(function(b){ b.classList.add('is-in'); }); return; }
    if(!('IntersectionObserver' in window)){ beats.forEach(function(b){ b.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); } });
    }, { threshold: 0.32, rootMargin: '0px 0px -10% 0px' });
    beats.forEach(function(b){ io.observe(b); });
  }
  document.querySelectorAll('[data-bunk-story]').forEach(initStory);
  document.addEventListener('shopify:section:load', function(e){
    var s = e.target.querySelector('[data-bunk-story]'); if(s) initStory(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2bunk_product_pdp"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-bunk-pdp]').forEach(function(root){
    var isOil = root.dataset.isOil === 'true';
    var track = root.querySelector('[data-pdp-track]');
    var dots  = root.querySelector('[data-pdp-dots]');
    var thumbs= root.querySelector('[data-pdp-thumbs]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var sbPrice = root.querySelector('[data-pdp-sbprice]');
    var doseEl  = root.querySelector('[data-pdp-dose]');
    var dosetagEl = root.querySelector('[data-pdp-dosetag]');
    var tapeEl  = root.querySelector('[data-pdp-tape]');
    var variantInput = root.querySelector('[data-pdp-variant-id]');
    var sizeBase = null; // base price chosen by size toggle (oil)

    function escq(s){return (s||'').replace(/[&<>]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;'}[c];});}
    function doseHtml(raw){ // wrap mg between ## markers in red
      if(!raw) return '';
      var parts = raw.split('##');
      var out=''; for(var i=0;i<parts.length;i++){ out += (i%2===1) ? '<span class="bunk-hl">'+escq(parts[i])+'</span>' : escq(parts[i]); }
      return out;
    }

    /* ── carousel dots ── */
    function buildDots(n){
      if(!dots) return;
      var h=''; for(var i=0;i<n;i++){ h+='<span class="bunk-pdp__gdot'+(i===0?' is-on':'')+'"></span>'; }
      dots.innerHTML=h;
    }
    function syncDots(){
      if(!track) return;
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if(dots){ var d=dots.children; for(var k=0;k<d.length;k++){ d[k].classList.toggle('is-on', k===i); } }
      if(thumbs){ var t=thumbs.querySelectorAll('[data-pdp-thumb]'); for(var k=0;k<t.length;k++){ t[k].classList.toggle('is-on', k===i); } }
    }
    if(track){
      buildDots(track.children.length);
      var scT;
      track.addEventListener('scroll', function(){ clearTimeout(scT); scT=setTimeout(syncDots,60); });
    }

    /* ── thumb → scrollTo ── */
    if(thumbs){
      thumbs.addEventListener('click', function(e){
        var btn = e.target.closest('[data-pdp-thumb]'); if(!btn||!track) return;
        var i = parseInt(btn.dataset.pdpThumb||'0',10);
        var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
        track.scrollTo({left:i*track.clientWidth, behavior: reduce?'auto':'smooth'});
      });
    }

    /* ── mood dots ── */
    function setMood(m){
      root.querySelectorAll('[data-mood]').forEach(function(x){
        if(!x.classList.contains('bunk-pdp__mdot')) return;
        var on = x.dataset.mood === m;
        x.classList.toggle('is-on', on);
        if(on && x.dataset.c){ root.style.setProperty('--ac', x.dataset.c); }
      });
    }

    /* ── variant pick (rebuild from server-rendered metafield data on the pill) ── */
    function pick(btn){
      root.querySelectorAll('[data-pdp-pick]').forEach(function(b){
        var on = b===btn; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on?'true':'false');
      });
      if(variantInput) variantInput.value = btn.dataset.pdpPick;

      var basePrice = sizeBase || btn.dataset.price;
      if(priceEl) priceEl.textContent = basePrice;
      if(sbPrice) sbPrice.textContent = basePrice;
      if(doseEl)  doseEl.innerHTML = doseHtml(btn.dataset.dose);
      if(dosetagEl) dosetagEl.innerHTML = btn.dataset.dosetag ? '<span class="bunk-dtag">'+escq(btn.dataset.dosetag)+'</span>' : '';

      var strainEls = root.querySelectorAll('[data-pdp-strain]');
      strainEls.forEach(function(el){ if(btn.dataset.strain) el.textContent = btn.dataset.strain; });

      if(tapeEl && btn.dataset.tape && !isOil){
        var tape = btn.dataset.tape, tu = tape.toUpperCase();
        tapeEl.style.background = tape;
        tapeEl.style.color = (tu==='#6F3FA3'||tu==='#4DB8A0'||tu==='#1F4D3A') ? '#f4f0e2' : '#1a1608';
      }
      if(btn.dataset.accent) root.style.setProperty('--ac', btn.dataset.accent);
      if(btn.dataset.mood) setMood(btn.dataset.mood);

      // NOTE: per-variant gallery swap requires the gallery image set in markup per variant.
      // Server-rendered single-variant galleries: a full SPA swap needs a JSON product feed.
      // Here we re-init dots/thumbs against whatever is currently in the track.
      if(track) buildDots(track.children.length);
      syncDots();
    }
    root.querySelectorAll('[data-pdp-pick]').forEach(function(b){
      b.addEventListener('click', function(){ pick(b); });
    });

    /* ── size toggle (oil) ── */
    root.querySelectorAll('[data-pdp-size]').forEach(function(b){
      b.addEventListener('click', function(){
        var grp = b.parentNode;
        grp.querySelectorAll('[data-pdp-size]').forEach(function(x){ x.classList.remove('is-on'); x.setAttribute('aria-checked','false'); });
        b.classList.add('is-on'); b.setAttribute('aria-checked','true');
        if(b.dataset.price){ sizeBase = b.dataset.price; if(priceEl) priceEl.textContent=b.dataset.price; if(sbPrice) sbPrice.textContent=b.dataset.price; }
      });
    });

    /* ── add to baggy → toast + bump count (form still submits to /cart/add) ── */
    var toast = root.querySelector('[data-pdp-toast]');
    var bagct = root.querySelector('[data-pdp-bagct]');
    root.querySelectorAll('[data-pdp-add]').forEach(function(b){
      b.addEventListener('click', function(){
        var nm = (root.querySelector('.bunk-pdp__sbname')||{}).textContent || '';
        var pr = priceEl ? priceEl.textContent : '';
        if(toast){
          toast.textContent = 'added · '+nm+' · '+pr;
          toast.classList.add('is-show');
          clearTimeout(window.__bunkPdpT);
          window.__bunkPdpT = setTimeout(function(){ toast.classList.remove('is-show'); }, 1700);
        }
        if(bagct){ bagct.textContent = (parseInt(bagct.textContent||'0',10)+1); }
      });
    });

    /* ── drawer ── */
    var drawer = root.querySelector('[data-pdp-drawer]');
    var scrim  = root.querySelector('[data-pdp-drawer-close]');
    function openDrawer(){ if(drawer){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); } root.querySelectorAll('.bunk-pdp__scrim').forEach(function(s){s.classList.add('is-open');}); }
    function closeDrawer(){ if(drawer){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); } root.querySelectorAll('.bunk-pdp__scrim').forEach(function(s){s.classList.remove('is-open');}); }
    root.querySelectorAll('[data-pdp-drawer-open]').forEach(function(b){ b.addEventListener('click', openDrawer); });
    root.querySelectorAll('[data-pdp-drawer-close]').forEach(function(b){ b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });

    /* ── 21+ age gate ── */
    var gate = root.querySelector('[data-pdp-agegate]');
    try{ if(sessionStorage.getItem('bunk21') && gate) gate.classList.add('is-hide'); }catch(e){}
    var yes = root.querySelector('[data-pdp-age-yes]');
    var no  = root.querySelector('[data-pdp-age-no]');
    if(yes) yes.addEventListener('click', function(){ if(gate) gate.classList.add('is-hide'); try{ sessionStorage.setItem('bunk21','1'); }catch(e){} });
    if(no)  no.addEventListener('click', function(){ window.location.href='https://www.google.com'; });

    // init mood from the selected pill
    var onPill = root.querySelector('[data-pdp-pick].is-on');
    if(onPill && onPill.dataset.mood) setMood(onPill.dataset.mood);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["3bunk-moods"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  /* ================================================================
     window.BunkCart — ONE shared add-to-cart engine (defined once,
     guarded; identical in every BUNK section). ADD TO BAGGY === add
     to the Shopify cart (POST /cart/add.js). No external asset/snippet.
     ================================================================ */
  if (!window.BunkCart) {
    window.BunkCart = (function () {
      function refresh() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-bunk-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.classList.toggle('is-empty', cart.item_count === 0);
            });
            document.dispatchEvent(new CustomEvent('bunk:cart:updated', { detail: cart }));
            return cart;
          })
          .catch(function () {});
      }
      function toast(msg) {
        var t = document.getElementById('bunk-cart-toast');
        if (!t) {
          t = document.createElement('div');
          t.id = 'bunk-cart-toast';
          t.setAttribute('role', 'status');
          t.setAttribute('aria-live', 'polite');
          t.style.cssText = 'position:fixed;left:50%;bottom:86px;transform:translateX(-50%) translateY(16px);z-index:120;background:#15120d;color:#FFE100;border:1px solid #5a4d18;padding:10px 16px;border-radius:9px;font-family:"Space Mono",ui-monospace,monospace;font-weight:700;font-size:12px;letter-spacing:.3px;opacity:0;transition:opacity .25s ease,transform .25s ease;pointer-events:none;white-space:nowrap;max-width:90vw;overflow:hidden;text-overflow:ellipsis';
          document.body.appendChild(t);
        }
        t.textContent = msg;
        requestAnimationFrame(function () { t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(0)'; });
        clearTimeout(window.__bunkToastT);
        window.__bunkToastT = setTimeout(function () { t.style.opacity = '0'; t.style.transform = 'translateX(-50%) translateY(16px)'; }, 2300);
      }
      function openCart(itemCount) {
        /* Horizon 2025 (3.0+): the theme listens for `cart:update` → it
           refreshes its own cart count AND opens its drawer. Harmless on
           themes that don't listen. THIS is the line that makes Horizon work. */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { itemCount: (itemCount == null ? undefined : itemCount), source: 'bunk-cart' } }
        }));
        document.dispatchEvent(new CustomEvent('bunk:cart:open'));
        /* Also drive the drawer element directly, across theme families. */
        var d = document.querySelector('cart-drawer, cart-drawer-component, #CartDrawer, #cart-drawer, .cart-drawer, [data-cart-drawer], .drawer--cart');
        if (d) {
          try {
            if (typeof d.open === 'function') { d.open(); }          /* Dawn-family: open() is a method */
            else if ('open' in d) { d.open = true; }                 /* Horizon: open is a boolean property */
            else { d.classList.add('is-open', 'active', 'open', 'drawer--active'); d.setAttribute('aria-hidden', 'false'); }
            if (typeof d.show === 'function') { d.show(); }
          } catch (e) {}
          return true;
        }
        return false;
      }
      function add(variantId, qty, meta) {
        meta = meta || {};
        variantId = (variantId == null ? '' : String(variantId)).replace(/[^0-9]/g, '');
        if (!variantId) {
          if (meta.url) { window.location.href = meta.url; return Promise.resolve(); }
          toast('connect this product in Shopify to enable add-to-baggy');
          return Promise.reject(new Error('no variant id'));
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
        })
          .then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw e; }); } return r.json(); })
          .then(function () { return refresh(); })
          .then(function (cart) {
            toast('added to your baggy' + (meta.name ? (' · ' + meta.name) : '') + (meta.price ? (' · ' + meta.price) : ''));
            var opened = openCart(cart && cart.item_count);
            /* No recognizable drawer on this theme → never leave the click silent: show the cart. */
            if (!opened) {
              setTimeout(function () {
                if (!document.querySelector('cart-drawer, cart-drawer-component, #CartDrawer, #cart-drawer, .cart-drawer, [data-cart-drawer], .drawer--cart')) {
                  window.location.href = '/cart';
                }
              }, 350);
            }
            return cart;
          })
          .catch(function (err) {
            toast((err && err.description) ? err.description : 'couldn’t add — check the product');
            throw err;
          });
      }
      function bunkBoot() {
        refresh();
        /* paper-grain overlay — auto-add if the theme didn't (styled by bunk-foundation.css .bunk-grain). Existence-checked = no doubling. */
        if (!document.querySelector('.bunk-grain')) { var g = document.createElement('div'); g.className = 'bunk-grain'; document.body.appendChild(g); }
        document.body.addEventListener('click', function (e) {
          var bag = e.target.closest && e.target.closest('[data-bunk-bag]');
          if (bag) { e.preventDefault(); if (!openCart()) { window.location.href = '/cart'; } }
        });
      }
      if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bunkBoot); } else { bunkBoot(); }
      return { add: add, refresh: refresh, toast: toast, openCart: openCart };
    })();
  }

  // var section = document.getElementById('bunk-moods-{{ section.id }}');
  var section = document.querySelector(".bunk-moods");
  if (!section) return;

  /* ---- PREFFERS REDUCED MOTION ---- */
  var prefersReduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- ACCORDION: tap mood card → toggle ladder ---- */
  var moods = section.querySelectorAll('.bm-mood');

  function openMood(el) {
    var ladder  = el.querySelector('.bm-ladder');
    var shopBtn = el.querySelector('[data-mood-toggle]');
    if (!ladder) return;
    var isOpen = el.classList.contains('is-open');

    // close all others first
    moods.forEach(function(m) {
      if (m !== el && m.classList.contains('is-open')) {
        closeMood(m);
      }
    });

    if (isOpen) {
      closeMood(el);
    } else {
      el.classList.add('is-open');
      ladder.removeAttribute('hidden');
      ladder.classList.add('is-open');
      if (shopBtn) shopBtn.setAttribute('aria-expanded', 'true');
    }
  }

  function closeMood(el) {
    var ladder  = el.querySelector('.bm-ladder');
    var shopBtn = el.querySelector('[data-mood-toggle]');
    el.classList.remove('is-open');
    if (ladder) {
      ladder.classList.remove('is-open');
      // wait for CSS transition before hiding from AT
      var delay = prefersReduced ? 0 : 340;
      setTimeout(function(){ if (!ladder.classList.contains('is-open')) ladder.setAttribute('hidden', ''); }, delay);
    }
    if (shopBtn) shopBtn.setAttribute('aria-expanded', 'false');
  }

  moods.forEach(function(mood) {
    // click on card (but not on chip buttons — those stopPropagation)
    mood.addEventListener('click', function(e) {
      // if click came from inside .bm-chip, ignore
      if (e.target.closest && e.target.closest('.bm-chip')) return;
      openMood(mood);
    });
    // keyboard: Enter / Space
    mood.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        if (e.target.closest && e.target.closest('.bm-chip')) return;
        e.preventDefault();
        openMood(mood);
      }
    });
    // make focusable if not already
    if (!mood.hasAttribute('tabindex')) mood.setAttribute('tabindex', '0');
    mood.setAttribute('role', 'button');
  });

  /* ---- SLIDESHOW + DOTS + ROTATING PRODUCT-FACT MARKER ---- */
  moods.forEach(function(mood) {
    var slides  = mood.querySelectorAll('.bm-slide');
    var dotsWrap= mood.querySelector('.bm-dots');
    var factEl  = mood.querySelector('.bm-fact');

    if (!slides.length) return;

    // build dot nodes
    slides.forEach(function(_, i) {
      var d = document.createElement('span');
      d.className = 'bm-dot' + (i === 0 ? ' bm-dot--on' : '');
      d.setAttribute('aria-hidden', 'true');
      if (dotsWrap) dotsWrap.appendChild(d);
    });

    var dots  = dotsWrap ? dotsWrap.querySelectorAll('.bm-dot') : [];
    var facts = [];
    try { facts = JSON.parse(mood.dataset.facts || '[]'); } catch(e){}
    var current = 0;

    function step() {
      slides[current].classList.remove('bm-slide--on');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) dots[current].classList.remove('bm-dot--on');
      current = (current + 1) % slides.length;
      slides[current].classList.add('bm-slide--on');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) dots[current].classList.add('bm-dot--on');
      if (factEl && facts[current % facts.length]) {
        factEl.textContent = facts[current % facts.length];
      }
    }

    if (slides.length > 1 && !prefersReduced) {
      setInterval(step, 4000);
    }
  });

  /* ---- ADD TO BAGGY → real Shopify cart (/cart/add.js via window.BunkCart) ---- */
  section.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-bag]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';
    btn.classList.add('is-busy');
    var name = btn.dataset.bag || '';
    var price = btn.dataset.price || '';
    var vid  = btn.dataset.variantId || '';
    var url  = btn.dataset.productUrl || '';
    window.BunkCart.add(vid, 1, { name: name, price: price, url: url })
      .catch(function(){})
      .then(function(){ btn.dataset.busy = '0'; btn.classList.remove('is-busy'); });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["4bunk-formate"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ================================================================
     window.BunkCart — ONE shared add-to-cart engine for the whole site.
     Defined once (guarded); every BUNK section reuses it. No external
     asset to forget, no snippet to miss — it can't break the build.
     ADD TO BAGGY === add to the Shopify cart (POST /cart/add.js).
     ================================================================ */
  if (!window.BunkCart) {
    window.BunkCart = (function () {
      function refresh() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-bunk-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.classList.toggle('is-empty', cart.item_count === 0);
            });
            document.dispatchEvent(new CustomEvent('bunk:cart:updated', { detail: cart }));
            return cart;
          })
          .catch(function () {});
      }
      function toast(msg) {
        var t = document.getElementById('bunk-cart-toast');
        if (!t) {
          t = document.createElement('div');
          t.id = 'bunk-cart-toast';
          t.setAttribute('role', 'status');
          t.setAttribute('aria-live', 'polite');
          t.style.cssText = 'position:fixed;left:50%;bottom:86px;transform:translateX(-50%) translateY(16px);z-index:120;background:#15120d;color:#FFE100;border:1px solid #5a4d18;padding:10px 16px;border-radius:9px;font-family:"Space Mono",ui-monospace,monospace;font-weight:700;font-size:12px;letter-spacing:.3px;opacity:0;transition:opacity .25s ease,transform .25s ease;pointer-events:none;white-space:nowrap;max-width:90vw;overflow:hidden;text-overflow:ellipsis';
          document.body.appendChild(t);
        }
        t.textContent = msg;
        requestAnimationFrame(function () { t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(0)'; });
        clearTimeout(window.__bunkToastT);
        window.__bunkToastT = setTimeout(function () { t.style.opacity = '0'; t.style.transform = 'translateX(-50%) translateY(16px)'; }, 2300);
      }
      function openCart(itemCount) {
        /* Horizon 2025 (3.0+): the theme listens for `cart:update` → it
           refreshes its own cart count AND opens its drawer. Harmless on
           themes that don't listen. THIS is the line that makes Horizon work. */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { itemCount: (itemCount == null ? undefined : itemCount), source: 'bunk-cart' } }
        }));
        document.dispatchEvent(new CustomEvent('bunk:cart:open'));
        /* Also drive the drawer element directly, across theme families. */
        var d = document.querySelector('cart-drawer, cart-drawer-component, #CartDrawer, #cart-drawer, .cart-drawer, [data-cart-drawer], .drawer--cart');
        if (d) {
          try {
            if (typeof d.open === 'function') { d.open(); }          /* Dawn-family: open() is a method */
            else if ('open' in d) { d.open = true; }                 /* Horizon: open is a boolean property */
            else { d.classList.add('is-open', 'active', 'open', 'drawer--active'); d.setAttribute('aria-hidden', 'false'); }
            if (typeof d.show === 'function') { d.show(); }
          } catch (e) {}
          return true;
        }
        return false;
      }
      function add(variantId, qty, meta) {
        meta = meta || {};
        variantId = (variantId == null ? '' : String(variantId)).replace(/[^0-9]/g, '');
        if (!variantId) {
          /* No variant wired yet → never a dead button: go to the product page. */
          if (meta.url) { window.location.href = meta.url; return Promise.resolve(); }
          toast('connect this product in Shopify to enable add-to-baggy');
          return Promise.reject(new Error('no variant id'));
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
        })
          .then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw e; }); } return r.json(); })
          .then(function () { return refresh(); })
          .then(function (cart) {
            toast('added to your baggy' + (meta.name ? (' · ' + meta.name) : '') + (meta.price ? (' · ' + meta.price) : ''));
            var opened = openCart(cart && cart.item_count);
            /* No recognizable drawer on this theme → never leave the click silent: show the cart. */
            if (!opened) {
              setTimeout(function () {
                if (!document.querySelector('cart-drawer, cart-drawer-component, #CartDrawer, #cart-drawer, .cart-drawer, [data-cart-drawer], .drawer--cart')) {
                  window.location.href = '/cart';
                }
              }, 350);
            }
            return cart;
          })
          .catch(function (err) {
            toast((err && err.description) ? err.description : 'couldn’t add — check the product');
            throw err;
          });
      }
      function bunkBoot() {
        refresh();
        /* paper-grain overlay — auto-add if the theme didn't (styled by bunk-foundation.css .bunk-grain). Existence-checked = no doubling. */
        if (!document.querySelector('.bunk-grain')) { var g = document.createElement('div'); g.className = 'bunk-grain'; document.body.appendChild(g); }
        /* any "your baggy" pill opens the cart */
        document.body.addEventListener('click', function (e) {
          var bag = e.target.closest && e.target.closest('[data-bunk-bag]');
          if (bag) { e.preventDefault(); if (!openCart()) { window.location.href = '/cart'; } }
        });
      }
      if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bunkBoot); } else { bunkBoot(); }
      return { add: add, refresh: refresh, toast: toast, openCart: openCart };
    })();
  }

  var SLIDE_INTERVAL = 4000;
  var TOAST_DURATION = 1700;
  var toastTimer = null;
  var slideTimers = {};

  /* ── helpers ── */
  function reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ── ACCORDION — tap card (one open at a time, keyboard-operable) ── */
  function initAccordion(section) {
    section.querySelectorAll('[data-card-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var card = btn.closest('.bunk-format__card');
        var ladder = card.querySelector('.bunk-format__ladder');
        var isOpen = card.classList.contains('open');

        // Close all siblings
        section.querySelectorAll('.bunk-format__card.open').forEach(function (c) {
          c.classList.remove('open');
          var l = c.querySelector('.bunk-format__ladder');
          var b = c.querySelector('[data-card-toggle]');
          if (l) { l.removeAttribute('style'); }
          if (b) { b.setAttribute('aria-expanded', 'false'); }
        });

        if (!isOpen) {
          card.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
          if (ladder) {
            // force reflow then animate
            ladder.style.maxHeight = ladder.scrollHeight + 'px';
          }
        }
      });

      /* keyboard: Enter/Space handled natively for <button>; also support Escape */
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          var card = btn.closest('.bunk-format__card');
          var ladder = card.querySelector('.bunk-format__ladder');
          card.classList.remove('open');
          btn.setAttribute('aria-expanded', 'false');
          if (ladder) ladder.style.maxHeight = '';
          btn.focus();
        }
      });
    });
  }

  /* ── ADD TO BAGGY → real Shopify cart (/cart/add.js via window.BunkCart) ── */
  function initAddToBaggy(section) {
    section.querySelectorAll('[data-add-to-baggy]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var chip = btn.closest('.bunk-format__chip');
        if (!chip) return;
        var mood   = chip.dataset.mood   || '';
        var price  = chip.dataset.price  || '';
        var format = chip.dataset.format || '';
        var vid    = chip.dataset.variantId || '';
        var url    = chip.dataset.productUrl || chip.getAttribute('href') || '';

        if (btn.dataset.busy === '1') return;
        btn.dataset.busy = '1';
        btn.classList.add('is-busy');

        window.BunkCart.add(vid, 1, { name: format + ' · ' + mood, price: price, url: url })
          .catch(function () {})
          .then(function () { btn.dataset.busy = '0'; btn.classList.remove('is-busy'); });
      });
    });
  }

  /* ── CROSSFADE SLIDESHOW ── */
  function stepCard(cardEl) {
    var slides = cardEl.querySelectorAll('.bunk-format__slide');
    var dots   = cardEl.querySelectorAll('.bunk-format__dot');
    if (slides.length < 2) return;
    var cur = -1;
    slides.forEach(function (s, i) { if (s.classList.contains('on')) cur = i; });
    if (cur < 0) cur = 0;
    slides[cur].classList.remove('on');
    if (dots[cur]) dots[cur].classList.remove('on');
    var nxt = (cur + 1) % slides.length;
    slides[nxt].classList.add('on');
    if (dots[nxt]) dots[nxt].classList.add('on');
  }

  function initSlideshows(section) {
    if (reduceMotion()) return;
    section.querySelectorAll('.bunk-format__card').forEach(function (card, i) {
      if (card.querySelectorAll('.bunk-format__slide').length > 1) {
        slideTimers[i] = setInterval(function () { stepCard(card); }, SLIDE_INTERVAL + i * 400);
      }
    });
  }

  /* ── INIT ── */
  function init(section) {
    initAccordion(section);
    initAddToBaggy(section);
    initSlideshows(section);
  }

  /* Shopify theme editor: re-init when section is reloaded */
  document.addEventListener('shopify:section:load', function (e) {
    var sec = document.getElementById('bunk-format-' + e.detail.sectionId);
    if (sec) init(sec);
  });

  /* On DOM ready */
  document.querySelectorAll('.bunk-format').forEach(function (sec) {
    init(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["5bunk-proof"] && !Shopify.designMode) return;
  try {
    
// bunk-proof — minimal JS
// No carousel, no accordion. The only optional interaction: keyboard-accessible
// COA link open (handled natively by <a> + target="_blank").
// Respects prefers-reduced-motion via bunk-base.css global rule.
(function() {
  'use strict';

  // Receipt tilt: mild parallax-on-scroll for receipts (desktop only, reduced-motion safe)
  var mq = window.matchMedia('(prefers-reduced-motion: no-preference)');
  if (!mq.matches) return;

  var section = document.getElementById('bunk-proof-{{ section.id }}');
  if (!section) return;

  var receipts = section.querySelectorAll('.bp-receipt');
  if (!receipts.length) return;

  // Subtle lift on scroll — only runs once IntersectionObserver fires
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('bp-receipt--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  receipts.forEach(function(r) { observer.observe(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunk_story"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function initStory(root){
    if(!root || root._bsInit) return; root._bsInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    /* ---- carousels ---- */
    root.querySelectorAll('[data-bs-carousel]').forEach(function(car){
      var track = car.querySelector('[data-bs-track]');
      var dotsC = car.querySelector('[data-bs-dots]');
      var prev = car.querySelector('[data-bs-prev]');
      var next = car.querySelector('[data-bs-next]');
      var autob = car.querySelector('[data-bs-auto]');
      var autoMode = (car.getAttribute('data-auto') !== 'false' && !reduce);
      var iv = null, vis = false, st = null;
      function slides(){ return Array.prototype.slice.call(track.querySelectorAll(':scope > .bs-cslide')); }
      function idx(){ return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
      function go(i){ var n = slides().length; i = Math.max(0, Math.min(i, n-1)); track.scrollTo({ left: i*track.clientWidth, behavior:'smooth' }); }
      function sync(){ var i = idx(); dotsC.querySelectorAll('.bs-cdot').forEach(function(d,j){ var on = j===i; d.classList.toggle('is-on', on); d.setAttribute('aria-selected', on ? 'true' : 'false'); }); }
      function tick(){ var n = slides().length; if(n<2) return; var i = idx()+1; if(i>=n) i=0; go(i); }
      function runAuto(){ if(!autoMode || !vis) return; clearInterval(iv); iv = setInterval(tick, 7000); }
      function haltAuto(){ clearInterval(iv); iv = null; }
      function killAuto(){ autoMode = false; haltAuto(); if(autob) autob.textContent = '▶'; }
      function buildDots(){
        var ss = slides(), solo = ss.length < 2;
        [prev,next,autob].forEach(function(b){ if(b) b.classList.toggle('is-gone', solo); });
        dotsC.style.display = solo ? 'none' : 'flex';
        dotsC.innerHTML = '';
        if(solo){ haltAuto(); return; }
        ss.forEach(function(s,i){ var d = document.createElement('button'); d.type='button'; d.className='bs-cdot'; d.setAttribute('role','tab'); d.setAttribute('aria-label','go to photo '+(i+1)); d.onclick = function(){ killAuto(); go(i); }; dotsC.appendChild(d); });
        sync();
      }
      track.addEventListener('scroll', function(){ clearTimeout(st); st = setTimeout(sync, 60); }, { passive:true });
      if(prev) prev.onclick = function(){ killAuto(); go(idx()-1); };
      if(next) next.onclick = function(){ killAuto(); go(idx()+1); };
      if(autob) autob.onclick = function(){ autoMode = !autoMode; autob.textContent = autoMode ? '⏸' : '▶'; autoMode ? runAuto() : haltAuto(); };
      ['touchstart','pointerdown','wheel'].forEach(function(ev){ track.addEventListener(ev, killAuto, { passive:true }); });
      car.addEventListener('mouseenter', haltAuto);
      car.addEventListener('mouseleave', runAuto);
      car.addEventListener('focusin', haltAuto);
      car.addEventListener('focusout', runAuto);
      if(autob) autob.textContent = autoMode ? '⏸' : '▶';
      buildDots();
      /* auto-advance ONLY while on screen — don't churn off-screen or slide the hero away before you arrive */
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){ es.forEach(function(e){ vis = e.isIntersecting; e.isIntersecting ? runAuto() : haltAuto(); }); }, { threshold:.55 }).observe(car);
      } else { vis = true; }
      /* boot fallback (IO first callback can lag in embedded webviews) */
      var r = car.getBoundingClientRect();
      if(r.top < innerHeight*0.6 && r.bottom > innerHeight*0.4){ vis = true; if(autoMode && slides().length>1) runAuto(); }
    });

    /* chapter nav lives in the SITE menu (links to #story-beat-N); the beats' scroll-margin-top
       handles the header offset for those anchor jumps — no in-section drawer JS needed. */

    /* ---- sampler capture: gate submit on the 21+/consent checkbox ---- */
    root.querySelectorAll('[data-bs-capform]').forEach(function(f){
      var c = f.querySelector('[data-bs-consent]'); var s = f.querySelector('[data-bs-capsubmit]');
      if(c && s){ var upd = function(){ s.disabled = !c.checked; }; c.addEventListener('change', upd); upd(); }
    });
  }
  document.querySelectorAll('[data-bunk-story]').forEach(initStory);
  document.addEventListener('shopify:section:load', function(e){ var s = e.target.querySelector('[data-bunk-story]'); if(s){ s._bsInit = false; initStory(s); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
